/** What the user picked. */
export type ThemeMode = 'dark' | 'light' | 'system';

/** What is actually rendered once `system` has been resolved. */
export type ResolvedTheme = 'dark' | 'light';

export function isThemeMode(value: unknown): value is ThemeMode {
  return value === 'light' || value === 'dark' || value === 'system';
}
